import { render } from "./WebStoreCard.vue?vue&type=template&id=662ffb04&scoped=true"
import script from "./WebStoreCard.vue?vue&type=script&lang=js"
export * from "./WebStoreCard.vue?vue&type=script&lang=js"

import "./WebStoreCard.vue?vue&type=style&index=0&id=662ffb04&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662ffb04"]])

export default __exports__